// Internal "object clipboard" for Navicat-style cross-connection/database
// copy-paste. Holds the LAST copied selection until replaced (a global signal so
// it survives navigating between connection tabs / databases). The payload is a
// reference to the source objects — the actual DDL + data are fetched server-side
// at paste time (see /api/object-copy). See OBJECT_COPY_SPEC.md.
import { createSignal } from 'solid-js';

// { sourceConnId, sourceConnName, sourceDb, items: [{ kind, name }] } | null
const [objectClipboard, setObjectClipboard] = createSignal(null);

export { objectClipboard };

export function copyObjectsToClipboard(payload) {
  if (!payload || !(payload.items || []).length) return;
  setObjectClipboard(payload);
}

export function clearObjectClipboard() { setObjectClipboard(null); }

export function clipboardCount() { return objectClipboard()?.items?.length || 0; }
